/// <reference path="../services/countryPicker.service.ts"/>
'use strict';

namespace ekh {

    type Tenant = TR.ITenant;
    type Region = TR.IRegion & {GaEventLabel: string};
    type PointOfSale = TR.IPointOfSale;
    type Language = TR.ILanguage;
    type IGlobalisationService = TR.IGlobalisationService;
    type IRegionalContext = TR.IRegionalContext;
    type IRegionTitle = TR.IRegionTitle;
    type IDomain = TR.IDomain;

    class CountryPickerDropdown {

        tenant:Tenant;
        regions:Region[];
        pointsOfSale:PointOfSale[];
        activeContext: IRegionalContext;
        currentDomain:IDomain;
        open:boolean = false;
        template:string;
        regionTitles:IRegionTitle[];

        constructor(private countryPickerService:ICountryPickerService,
                    private broker:any,
                    private resourceService:any) {

            this.regionTitles = [
                {Id: 1, Title: this.resourceService.getDeferred('REGIONTITLE_AMERICA'), GaEventLabel: 'Americas'},
                {Id: 2, Title: this.resourceService.getDeferred('REGIONTITLE_EUROPE'), GaEventLabel: 'Europe'},
                {Id: 3, Title: this.resourceService.getDeferred('REGIONTITLE_MIDDLEEAST'), GaEventLabel: 'MiddleEast'},
                {Id: 4, Title: this.resourceService.getDeferred('REGIONTITLE_AFRICA'), GaEventLabel: 'Africa'},
                {Id: 5, Title: this.resourceService.getDeferred('REGIONTITLE_ASIA'), GaEventLabel: 'Asia&SouthPacific'},
                {Id: 6, Title: this.resourceService.getDeferred('REGIONTITLE_RESTOFTHEWORLD'),
                    GaEventLabel: 'RestOfTheWorld'}
            ];

            this.countryPickerService.getDomain()
                .then((domain: IDomain) => {
                    this.regions = domain.Regions.map(r => {
                        const {Title, GaEventLabel} = _.find(this.regionTitles, region => region.Id === r.Id);
                        r.Title = Title;
                        return {
                            ...r,
                            Title,
                            GaEventLabel

                        };
                    });
                    this.currentDomain = _.cloneDeep(domain);
                    this.activeContext = domain.Context;
                    this.pointsOfSale = this.getPointsOfSale();
                    if(this.activeContext.Inferred){
                        this.confirmRegionalContext(true);
                    }
                });
        }

        selectRegion = (id:number):void => {
            this.activeContext.Region = _.find(this.regions, (r => r.Id === id));
            this.pointsOfSale = this.getPointsOfSale();
            this.activeContext.PointOfSale = this.pointsOfSale[0];
            const languages = this.activeContext.PointOfSale.Context.Languages;
            this.activeContext.Language = languages.length > 0 ? languages[0] : null;
        }

        getPointsOfSale = ():PointOfSale[] => {
            const france = {
                Id: 999,
                Name: 'France',
                PosEnglishName: 'France',
                RegionId: 2,
                Context: {
                    AccountingCurrency: 'EUR',
                    CultureCode: 'fr-fr',
                    DefaultCurrency: 'EUR',
                    DomainName: 'emiratesholidays.com',
                    IsAgent: false,
                    Languages: [
                        {Code: 'en-fr', Name: 'French'}
                    ],
                    LegacyDomain: 999,
                    TradingGroup: 999,
                },
                Country: {
                    Code: 'FR',
                    LocalName: 'France',
                    LocalisedNames: [
                        {Name: 'France', CultureCode: 'fr-fr'}
                    ],
                    Name: 'France',
                },
                CountryCode: 'FR',
                CountryId: 999,
                Enabled: true
            };

            let activeContextPOS = this.activeContext.Region.PointsOfSale;

            if(this.activeContext.Region.Id === 2) {
                activeContextPOS = [france, ...activeContextPOS];

            }
            let pointsofsale = activeContextPOS.map(pos => {
                const names = pos.Country.LocalisedNames.find(name => {
                    return name.CultureCode === _.get(this.currentDomain, 'Context.Language.Code', '');
                });
                const localisedNames = names ? [names] : pos.Country.LocalisedNames;
                return {
                    ...pos,
                    PosEnglishName: this.getPosEnglishName(pos),
                    Country: {
                        ...pos.Country,
                        LocalisedNames: localisedNames,
                        LocalName : localisedNames[0].Name
                    }
                };
            });
            pointsofsale.sort((a, b) => {
                return (a.Country.LocalName).localeCompare(b.Country.LocalName);
            });
            return pointsofsale;
        }

        selectPointOfSale = (pos:PointOfSale):void => {
            if(pos){
                this.activeContext.Language = pos.Context.Languages.length > 0 ? pos.Context.Languages[0] : null;
            }
        }

        getPosEnglishName = (pos): string => {
            if (!pos || !pos.Country || !(pos.Country.LocalisedNames instanceof Array)) {
                return '';
            }
            const englishCountryName = pos.Country.LocalisedNames.filter( langObj => {
                return langObj.CultureCode === 'en-GB';
            });
            return englishCountryName.length ? englishCountryName[0].Name : '';
        }

        confirmRegionalContext(inferred):void {
            if(this.activeContext.PointOfSale.Name === 'France') {
                window.location.replace('https://www.emiratesholidays.fr/');
            } else {
                this.open = false;
                this.activeContext.Inferred = inferred;
                this.broker.publish('RegionalContextSelected', this.activeContext);
            }
        }
    }

    angular
        .module('ekh')
        .directive('countryPickerDropdown', () => {
            return {
                restrict: 'E',
                scope:{
                    open: '='
                },
                templateUrl: 'partials/home/directivetemplate?type=countrypickerdropdown',
                controller: CountryPickerDropdown,
                controllerAs: 'cm',
                bindToController: true
            };
        });

}
